import { H1 } from '@ahmdigital/ui';
import type { ReactNode } from 'react';

import styles from './styles.module.sass';

type HeroSectionContentProps = {
  afterTitle?: ReactNode;
  subtitle?: ReactNode;
  title: ReactNode;
};

const HeroSectionContent = ({ afterTitle, subtitle, title }: HeroSectionContentProps) => (
  <>
    <H1 variant="marginBottomSpacer11">{title}</H1>
    {afterTitle}
    {subtitle && <div className={styles.subtitleWrapper}>{subtitle}</div>}
  </>
);

export default HeroSectionContent;
